export function setItem(name: string, value: any) {
  localStorage.setItem(name, JSON.stringify(value));
}
export function getItem(name: string) {
  const localData = localStorage.getItem(name);
  if (localData) return JSON.parse(localData);
  return null;
}
export function removeItem(name: string) {
  localStorage.removeItem(name);
  return null;
}
export function getAccecssToken(name: string) {
  const localData = localStorage.getItem(name);
  if (localData) {
    const token = JSON.parse(localData);
    return token.accessToken as string;
  }
  return null;
}

export function getRefreshToken(name: string) {
  const localData = localStorage.getItem(name);
  if (localData) {
    const token = JSON.parse(localData);
    return token.refreshToken as string;
  }
  return null;
}

export function getToken(name: string) {
  const localData = localStorage.getItem(name);
  if (localData) {
    const token = JSON.parse(localData);
    return token;
  }
  return null;
}

export interface RESPONSETYPE {
  id: number;
  accessToken: string;
  refreshToken: string;
}
export const USERTOKEN = 'app.soundpill.user.nid.token';
export const USERINFO = 'app.soundpill.user.nid.info';
export const LocalLanguage = 'app.soundpill.ln.crnt';
export const SYSTEMTHEMESAVEINFO = 'app.soundpill.system.theme.nid';
export const RECENT_SOCIAL_LOGIN = 'app.social-login.platform';

// CommonHeader URL
export const DigitalNutritionURL = 'https://digitalnutrition.info/'
export const NiRestURL = 'https://dn-store.info/';

/** 헤더·홈 이지레스트 배너 — 네이버 스마트스토어 */
export const EASY_REST_SMARTSTORE_URL =
  'https://smartstore.naver.com/soundpill/products/12485349661';

export function openEasyRestSmartstore() {
  window.open(EASY_REST_SMARTSTORE_URL, '_blank', 'noopener,noreferrer');
}